import { ClientAction, ClientActionEnum, ClientState } from "./types";

const initialState: ClientState = {
  isLogin: localStorage.getItem("token") ? true : false,
  id: null,
  isLoading: {
    login: false,
    signup: false,
    get: false,
    pay: false,
  },
  result: {},
};

const client = (state = initialState, action: ClientAction): ClientState => {
  switch (action.type) {
    case ClientActionEnum.REQUEST_LOGIN:
      return {
        ...state,
        isLoading: { ...state.isLoading, login: true },
        result: { ...state.result, login: '' }
      };
    case ClientActionEnum.RESULT_LOGIN:
      return {
        ...state,
        isLogin: !!action.token,
        isLoading: { ...state.isLoading, login: false },
        result: { ...state.result, login: action.status },
        id: action.id,
      };
    case ClientActionEnum.ERROR_LOGIN:
      return {
        ...state,
        isLogin: false,
        isLoading: { ...state.isLoading, login: false },
        result: { ...state.result, login: action.result },
      };
    case ClientActionEnum.EXIT:
      return {
        ...state,
        isLogin: false,
        result: { ...state.result, login: action.result ?? "" },
      };
    case ClientActionEnum.REQUEST_SIGNUP:
      return {
        ...state,
        isLoading: { ...state.isLoading, signup: true },
        result: { ...state.result, signup: '' }
      };
    case ClientActionEnum.RESULT_SIGNUP:
      return {
        ...state,
        isLoading: { ...state.isLoading, signup: false },
        result: { ...state.result, signup: action.user },
      };
    case ClientActionEnum.REQUEST_CLIENT:
      return {
        ...state,
        isLoading: { ...state.isLoading, get: true },
        result: { ...state.result, get: '' }
      };
    case ClientActionEnum.RESULT_CLIENT:
      return {
        ...state,
        isLoading: { ...state.isLoading, get: false },
        result: { ...state.result, get: action.status },
        client: action.data.client,
        orderList: action.data.orderList
      };
    case ClientActionEnum.REQUEST_CLIENT_PAY:
      return {
        ...state,
        isLoading: { ...state.isLoading, pay: true },
        result: { ...state.result, pay: '' }
      };
    case ClientActionEnum.RESULT_CLIENT_PAY:
      return {
        ...state,
        isLoading: { ...state.isLoading, pay: false },
        result: { ...state.result, pay: action.data },
      };
    default:
      return state;
  }
};
export default client;
